<template>
    <div>
        <loading-component :value="loading"/>
        <v-container :fluid="true" v-if="user" style="padding:0">
            <v-layout column>
                <v-flex xs12 class="item">
                    <v-card color="secondary darken-1" class="white--text">
                        <v-layout align-center>
                            <v-flex xs2>
                                <v-img
                                        :src="api.GET_IMAGE(_user.profile_image)"
                                        height="125px"
                                        contain
                                ></v-img>
                            </v-flex>
                            <v-flex xs8>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="headline">{{_user.first_name + ' ' + _user.last_name}}</div>
                                        <div>{{_user.username}}</div>
                                        <div>{{_user.phone_number}}</div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                            <v-flex xs2>


                                <v-btn @click="addNoteDialog=true">
                                    Add new Note
                                </v-btn>
                                <v-btn @click="applyJustifyTicket=true">
                                    Apply Justify Ticket
                                </v-btn>

                                <v-dialog
                                        v-model="addNoteDialog"
                                        width="500"
                                >
                                    <v-card
                                            dark
                                    >
                                        <v-card-text>
                                            <note-edit-component v-model="note" @submit="sendNote"/>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                                <v-dialog
                                        v-model="applyJustifyTicket"
                                        width="500"
                                >
                                    <v-card>
                                        <v-card-text>
                                            <justification-ticket-form
                                                    v-on:close-dialog="applyJustifyTicket = false"></justification-ticket-form>
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>

                            </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-tabs
                            v-model="tab"
                            color="secondary"
                            grow
                    >
                        <v-tabs-slider color="white"></v-tabs-slider>

                        <v-tab
                                v-for="item in items"
                                :key="item"
                                :disabled="loading"
                        >
                            {{ item }}
                        </v-tab>
                        <v-tab-item>
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex sm12>
                                        <v-widget title="User Info">
                                            <div slot="widget-content">
                                                <v-container>
                                                    <v-form ref="form" class="fa-border pa-5 mb-3">
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Photo</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <img :src="imageUrl" height="150" v-if="imageUrl"/>
                                                                <v-text-field label="Select Image"
                                                                              @click='$refs.image.click()'
                                                                              v-model='imageName'
                                                                              append-icon='attach_file'
                                                                              readonly
                                                                ></v-text-field>
                                                                <input
                                                                        type="file"
                                                                        style="display: none"
                                                                        ref="image"
                                                                        accept="image/*"
                                                                        @change="onFilePicked"
                                                                >

                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>User's Email</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        label="E-mail"
                                                                        v-model="user.username"
                                                                        :rules="[rules.required, rules.email]"
                                                                        append-icon="email"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row v-if="hasPermission('ROLES')">
                                                            <v-flex xs4>
                                                                <v-subheader>Role</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <choose-role
                                                                        label="Role"
                                                                        v-model="user.role_id"
                                                                        :rules="[rules.required]"
                                                                        append-icon="user"
                                                                ></choose-role>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Password</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        label="Password"
                                                                        v-model="user.password"
                                                                        :rules="[rules.password]"
                                                                        type="password"
                                                                        append-icon="vpn_key"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Password Confirmation</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        label="Password Confirmation"
                                                                        v-model="user.password_confirmation"
                                                                        :rules="[rules.password_confirm]"
                                                                        type="password"
                                                                        append-icon="vpn_key"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>First name</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        v-model="user.first_name"
                                                                        label="First name"
                                                                        color="primary"
                                                                        append-icon="person"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Last name</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        v-model="user.last_name"
                                                                        label="Last name"
                                                                        color="primary"
                                                                        append-icon="person"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Gender</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-select
                                                                        label="Gender"
                                                                        :items="[{text: 'Male',value: api.CONSTANTS.GENDER.MALE},{text: 'Female',value: api.CONSTANTS.GENDER.FEMALE}]"
                                                                        v-model="user.gender"
                                                                        append-icon="fa fa-venus-mars"
                                                                ></v-select>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Phone Number</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        name="Phone Number"
                                                                        label="Phone"
                                                                        v-model="user.phone_number"
                                                                        :rules="[rules.required, rules.phone]"
                                                                        append-icon="phone"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-flex xs4>
                                                                <v-subheader>Birthday</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-menu
                                                                        lazy
                                                                        :close-on-content-click="false"
                                                                        transition="scale-transition"
                                                                        offset-y
                                                                        full-width
                                                                        :nudge-bottom="-24"
                                                                        max-width="290px"
                                                                >
                                                                    <v-text-field
                                                                            slot="activator"
                                                                            label="Birthday"
                                                                            v-model="user.birthday"
                                                                            :rules="[rules.required]"
                                                                            append-icon="today"
                                                                            readonly
                                                                    ></v-text-field>
                                                                    <v-date-picker
                                                                            :max="today"
                                                                            v-model="user.birthday">
                                                                    </v-date-picker>

                                                                </v-menu>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row>
                                                            <v-btn color="primary"
                                                                   @click="save"
                                                            >Save
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-form>
                                                    <v-form class="fa-border pa-5">

                                                        <v-layout row v-if="isSuperAdmin">
                                                            <v-flex xs4>
                                                                <v-subheader>Salary</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        label="Salary"
                                                                        v-model="userMeta.salary"
                                                                        append-icon="attach_money"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row v-if="isSuperAdmin">
                                                            <v-flex xs4>
                                                                <v-subheader>Bank account</v-subheader>
                                                            </v-flex>
                                                            <v-flex xs8>
                                                                <v-text-field
                                                                        label="Bank Account Number"
                                                                        v-model="userMeta.bank_account_number"
                                                                        append-icon="account_balance"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-layout row>
                                                            <v-btn color="primary"
                                                                   @click="saveMeta"
                                                            >Save
                                                            </v-btn>
                                                        </v-layout>
                                                    </v-form>
                                                </v-container>
                                            </div>

                                        </v-widget>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                        </v-tab-item>
                        <v-tab-item lazy>
                            <v-card flat>
                                <v-card-text class="title">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <choose-date v-model="start" label="From"/>
                                        </v-flex>
                                        <v-flex xs6>
                                            <choose-date v-model="end" label="To"/>
                                        </v-flex>
                                        <v-flex xs6 class="mt-5">
                                            Tickets Assigned:
                                        </v-flex>
                                        <v-flex xs6 class="mt-5">
                                            {{stats.tickets_assigned}}
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            Tickets Resolved
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            {{stats.tickets_resolved}}
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            Active Tickets
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            {{stats.active_tickets}}
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            Avg Ticket Lifetime(Hour)
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            {{stats.avg_ticket_lifetime_hour}}
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            Rejection Rate
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            {{stats.rejection_rate * 100}} %
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            Average Delay(minute)
                                        </v-flex>
                                        <v-flex xs6 class="mt-4">
                                            {{stats.avg_delay}}
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item lazy>
                            <DataTable :url="api.ACTIONS.LOGS + '?type=users&id=' + user.id"
                                       :enable-delete="false"
                                       descending
                                       :sortable="false"
                                       :enable-edit="false"
                                       :enable-add="false"
                                       disable-search
                                       :title="false"
                                       :key="keys.logsTable"
                                       :titles="titles.logs"
                                       :fields-hidden-main="['event','auditable_id','auditable_type','old_values','new_values']"
                                       :formatter="formatter.logs"
                                       :fields-extra-main="fieldsExtraMain.logs"
                            />
                        </v-tab-item>
                        <v-tab-item lazy>
                            <DataTable :url="api.ACTIONS.NOTES + '?subject_type=users&subject_id=' + user.id"
                                       :enable-delete="false"
                                       descending
                                       :sortable="false"
                                       :enable-edit="false"
                                       :enable-add="false"
                                       disable-search
                                       :title="false"
                                       :key="keys.notesTable"
                                       :titles="titles.notes"
                                       :fields-hidden-main="['updated_at','subject_id','subject_type','author_type','author_id','subject']"
                                       :formatter="formatter.notes"
                            />
                        </v-tab-item>

                        <template v-if="this.$store.state.user.id == this.$route.params.id">
                            <v-tab-item lazy>
                                <my-leaves></my-leaves>
                            </v-tab-item>

                            <v-tab-item lazy>
                                <my-extra-hours></my-extra-hours>
                            </v-tab-item>

                            <v-tab-item lazy>
                                <salary-reports :enable_employee_choose="false"></salary-reports>
                            </v-tab-item>
                        </template>

                    </v-tabs>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import NoteEditComponent from "@/components/NoteEditorComponent";
    import VWidget from "@/components/VWidget";
    import moment from "moment";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseRole from "@/components/wasilni/input/ChooseRole";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import MyLeaves from "@/views/Leave/MyLeaves";
    import MyExtraHours from "@/views/extra_hours/MyExtraHours";
    import UserProjectSchedule from "@/views/UserProjectSchedule";
    import SalaryReports from "@/views/HRAccounting/SalaryReports";
    import JustificationTicketForm from "@/views/HRAccounting/JustificationTicketForm";

    export default {
        name: "UserProfile",
        title: 'User Profile',
        components: {
            JustificationTicketForm,
            SalaryReports,
            UserProjectSchedule,
            MyExtraHours,
            MyLeaves, ChooseDate, ChooseRole, LoadingComponent, DataTable, NoteEditComponent, VWidget
        },
        data() {
            return {
                isSuperAdmin: false,
                canEdit: true,
                rules: {
                    required: (value) => !!value || 'Required.',
                    email: (value) => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return pattern.test(value) || 'Invalid e-mail.';
                    },
                    phone: (value) => {
                        const pattern = /^\d{9}$/;
                        return pattern.test(value) || 'Invalid Phone number (must be exactly 9 digits)';
                    },
                    password: (value) => {
                        const pattern = /^(.|\s){6,32}$/;
                        return !value || pattern.test(value) || 'Password must be between 6 and 32 letters';
                    },
                    password_confirm: (value) => value === this.user.password || 'Must match password'
                },
                items: ['info', 'stats', 'log', 'notes', 'Leaves', 'Extra Hours', 'Salary Report'],
                tab: 0,
                user: null,
                userMeta: {
                    salary: null,
                    bank_account_number: null
                },
                _user: null, // snapshot to send only deleted fields
                stats: {
                    loaded: false,
                    tickets_assigned: null,
                    tickets_resolved: null,
                    active_tickets: null,
                    avg_ticket_lifetime_hour: null,
                    rejection_rate: null,
                    avg_delay: null
                },
                log: null,
                notes: null,
                note: null,
                start: moment().startOf('week').format("YYYY-MM-DD"),
                end: moment().endOf('week').format("YYYY-MM-DD"),
                addNoteDialog: false,
                applyJustifyTicket: false,
                loading: true,
                keys: {
                    notesTable: 1,
                    logsTable: 100
                },
                titles: {
                    notes: {
                        id: '#',
                        expiry_date: 'Expiry Date',
                        created_at: 'Creation Date',
                        author: "Author",
                        note: "Note"
                    },
                    logs: {
                        created_at: "Date",
                        id: "#",
                        action: "Action"
                    }
                },
                imageName: '',
                imageUrl: '',
                imageFile: '',
                fieldsExtraMain: {
                    logs: {
                        action({auditable_type, auditable_id, event}) {
                            const resourceName = auditable_type.split("\\").splice(-1);
                            if (event.toLowerCase() === 'created')
                                return `Created new ${resourceName} with id ${auditable_id}`;
                            return `${event.charAt(0).toUpperCase() + event.slice(1).toLowerCase()} ${resourceName} with id ${auditable_id}`;
                        }
                    }
                },
                formatter: {
                    notes: {
                        author(value) {
                            return `${value.first_name} ${value.last_name} (${value.username})`
                        },
                        expiry_date(value) {
                            if (!value) return "For Ever";
                            return (new Date(value)).toLocaleDateString();
                        },
                        created_at(value) {
                            return (new Date(value)).toLocaleString()
                        }
                    },
                    logs: {
                        created_at(value) {
                            return (new Date(value)).toLocaleString();
                        }
                    }
                }
            };
        },
        mounted() {
            this.axios.get(this.api.ACTIONS.USERS + '/' + this.$route.params.id)
                .then(
                    ({data}) => {
                        this.user = data.data;
                        this._user = Object.assign({}, this.user);
                        this.loading = false;
                        for (let i = 0; i < this.$store.state.user.roles.length; i++) {
                            if (this.$store.state.user.roles[i].name == 'Super Admin') {
                                this.isSuperAdmin = true;
                            }
                        }
                        if (this.isSuperAdmin) {
                            this.userMeta.salary = this.user.salary;
                            this.userMeta.bank_account_number = this.user.bank_account_number;
                        }
                    }
                )
                .catch(
                    () => this.$router.push({name: "NotFound"})
                )
        },
        watch: {
            tab(value) {
                const key = this.items[value];
                switch (key) {
                    case "stats":
                        if (!this.stats.loaded)
                            this.loadStats();
                        break;
                }
            },
            start() {
                this.loadStats();
            },
            end() {
                this.loadStats();
            }
        },
        methods: {
            async loadStats() {
                this.loading = true;
                try {
                    const params = new URLSearchParams();
                    params.append('start', this.start + " 00:00:00");
                    params.append('end', this.end + " 23:59:59");
                    const {data: {data: stats}} = await this.axios.get(this.api.ACTIONS.USER_STATS(this.$route.params.id), {params});
                    this.stats = stats;
                } catch (e) {
                    const {message} = e.response.data;
                    window.getApp.$emit("SHOW_TOAST", message, "red");
                } finally {
                    this.loading = false;
                }
            },
            sendNote() {
                this.loading = true;
                this.addNoteDialog = false;

                this.axios.post(this.api.ACTIONS.NOTES, Object.assign({}, this.note, {
                    subject_type: "users",
                    subject_id: this.user.id
                })).then(
                    () => {
                        this.loading = false;
                        window.getApp.$emit('SHOW_TOAST', 'SENT', 'green');
                        this.keys.notesTable++;
                    });
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageName = files[0].name;
                    if (this.imageName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result;
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                    })
                } else {
                    this.imageName = '';
                    this.imageFile = '';
                    this.imageUrl = '';
                }
            },
            save() {
                if (this.$refs.form.validate()) {
                    const updatedData = Object.keys(this.user).filter(key => this.user[key] !== this._user[key]).map(item => ({[item]: this.user[item]}));
                    if (this.imageFile)
                        updatedData.push({profile_image: this.imageFile});
                    if (updatedData.length > 0) {
                        this.loading = true;
                        const formData = new FormData();
                        formData.append("_method", "PUT");
                        for (const field of updatedData) {
                            const key = Object.keys(field)[0];
                            formData.append(key, field[key]);
                        }
                        this.axios.post(this.api.ACTIONS.USERS + '/' + this.user.id, formData)
                            .then(({data}) => {
                                if (this.user.id === this.$store.state.user.id)
                                    this.$store.commit('LOGIN', Object.assign({}, this.$store.state.user, data.data));
                                this.imageName = '';
                                this.imageFile = '';
                                this.imageUrl = '';
                                this.user = data.data;
                                this._user = Object.assign({}, this.user);
                                this.loading = false;
                                window.getApp.$emit('SHOW_TOAST', 'Saved');
                            });
                    }

                } else {
                    window.getApp.$emit("SHOW_TOAST", "Please check all fields", "red");
                }
            },
            saveMeta() {
                this.axios.put( 'user/' + this.user.id + '/meta', this.userMeta )
                    .then(res => {
                        this.userMeta = res.data.data;
                        window.getApp.$emit('SHOW_TOAST', 'Saved Meta');
                    })
                    .catch(error => {
                        window.getApp.$emit('SHOW_TOAST', error.response.data.message, 'red');
                        console.log(error);
                    })
            }

        },
        computed: {
            today() {
                return moment().format("YYYY-MM-DD");
            }
        }
    }

</script>

<style scoped>

</style>
